import storeRequest from './request/storeRequest';
import STORAGE_NAME from '@/const/storage';

export const chatbotApi = {
  getProductHistoryChats(productId, type) {
    return storeRequest.get(`/products/history-chat/${productId}`, {
      // type: 'product_insight' | 'ads_content'
      params: { type },
    });
  },

  sendMessageWithAdsContent(payload) {
    // payload: { productId, message, modelAI, prompt_type, attachments?, mode?: 'edit' | 'redesign' | 'concept' }
    return storeRequest.api.post('/products/ads-content/chat', payload, {
      timeout: 180000, // 3 minutes
    });
  },

  sharePromptChat(payload) {
    // payload: { productId: string, prompt_id: string, }
    return storeRequest.post('/products/share-promt/chat', payload);
  },

  getPromptTemplates(payload) {
    // payload: { prompt_type: 'template', catalog: string, page: number, limit: number, prompt: string }
    return storeRequest.get('/products/share-promt/search', {
      params: payload,
    });
  },

  updateChatMessageStatus(id, payload) {
    // payload: { status: 'stopped' }
    return storeRequest.patch(`/products/ads-content/chat/${id}/status`, payload);
  },

  async fetchMessageStream(body) {
    const token = localStorage.getItem(STORAGE_NAME.ACCESS_TOKEN);
    const storeId = localStorage.getItem(STORAGE_NAME.STORE_ID);
    const storeDomain = localStorage.getItem(STORAGE_NAME.STORE_DOMAIN);

    let CHAT_STREAM_API_BASE = '';
    if (storeDomain) {
      CHAT_STREAM_API_BASE = 'https://' + storeDomain + '/adlens/api/v1';
    }
    const response = await fetch(`${CHAT_STREAM_API_BASE}/chat/product`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-access-token': token,
        'x-store-id': storeId,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({ error: response.statusText }));
      throw new Error(`HTTP ${response.status}: ${err.error}`);
    }

    return response;
  },
};
